export default function sanitize(obj) {
  const objDraft = { ...obj };
  Object.keys(objDraft).forEach(
    (key) =>
      (objDraft[key] == null || objDraft[key] === '') && delete objDraft[key]
  );
  return objDraft;
}
